import AddCompetitor from './AddCompetitor';
import DeleteModal from './DeleteModal';

export { AddCompetitor, DeleteModal };
